var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5893 2.06867C17.2336 1.8894 17.9257 2.06694 18.4006 2.53338L21.4515 5.52947C21.9201 5.98969 22.1063 6.66145 21.9405 7.29367L20.8441 11.4732C20.6782 12.1054 20.1853 12.6029 19.5496 12.7798L15.4107 13.9313C14.7664 14.1106 14.0743 13.9331 13.5994 13.4666L13.5661 13.4339L11.8931 15.1069C11.812 15.188 11.7055 15.2387 11.5915 15.2507L9.61024 15.4578C9.37524 15.4824 9.18952 15.6681 9.16495 15.9031L8.9815 17.6575C8.95692 17.8925 8.7712 18.0782 8.53621 18.1028L6.78181 18.2863C6.54681 18.3108 6.36109 18.4966 6.33652 18.7316L6.12934 20.7128C6.11742 20.8269 6.06667 20.9333 5.98561 21.0144L5.14645 21.8536C5.05268 21.9473 4.9255 22 4.79289 22H2.5C2.22386 22 2 21.7761 2 21.5V19.2071C2 19.0745 2.05268 18.9473 2.14645 18.8536L10.5389 10.4611C10.0774 10.0011 9.89483 9.33423 10.0595 8.70633L11.1559 4.52684C11.3218 3.89462 11.8147 3.3971 12.4504 3.22021L16.5893 2.06867ZM19 7.5C19 6.11929 17.8807 5 16.5 5C15.1193 5 14 6.11929 14 7.5C14 8.88071 15.1193 10 16.5 10C17.8807 10 19 8.88071 19 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyAlt3);
export default __webpack_public_path__ + "static/media/key-alt-3.5af2b83ba669bb8e03255a336edf3d33.svg";
export { ForwardRef as ReactComponent };